import styled from 'styled-components'

import { mainColors, semanticColors } from '../../styles'
import { rgba } from '../../utils'

const CIRCLE_SIZE = 8

export const Root = styled.div`
  min-height: ${CIRCLE_SIZE}px;
  margin-top: 4px;
  display: flex;
  gap: 4px;
`

export const Circle = styled.div<{ $visited?: boolean; $pending?: boolean; $selected?: boolean }>`
  width: ${CIRCLE_SIZE}px;
  height: ${CIRCLE_SIZE}px;
  border-radius: ${CIRCLE_SIZE}px;
  background-color: ${mainColors.neutralDark};
  background-color: ${({ $pending }) => $pending && rgba(semanticColors.failureMedium, 0.8)};
  background-color: ${({ $visited }) => $visited && semanticColors.successMedium};
  background-color: ${({ $selected }) => $selected && mainColors.accentMedium};
  transform: ${({ $selected }) => $selected && 'scale(1.2)'};
`
